import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
import Location from '../views/Location.vue';
import LocationForm from '../views/Location.form.vue';
import Holiday from '../views/Holiday.vue';
import Invite from '../views/Invite.vue';
import AdminUser from '../views/adminUser/AdminUser.vue';
import AdminUserForm from '../views/adminUser/AdminUser.form.vue';

import securityService from '../services/SecurityService';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  }, {
    path: '/login',
    name: 'login',
    component: Login,
  }, {
    path: '/location',
    name: 'location',
    component: Location,
  }, {
    path: '/location/:id',
    name: 'LocationForm',
    component: LocationForm,
  }, {
    path: '/location/create',
    name: 'locationCreate',
    component: LocationForm,
  }, {
    path: '/holiday',
    name: 'holiday',
    component: Holiday,
  }, {
    path: '/admin-user',
    name: 'adminUser',
    component: AdminUser,
  },
  {
    path: '/admin-user/:id',
    name: 'adminUserForm',
    component: AdminUserForm,
  },
  {
    path: '/invite',
    name: 'invite',
    component: Invite,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  if (to.name === 'invite' || from.name === 'invite') {
    next();
    return;
  }

  const isAuth = securityService.isAuth();
  if (!isAuth && to.name !== 'login') {
    next({
      path: '/login',
      params: { nextUrl: to.fullPath }
    })
    return;
  }

  next();

})
export default router
